import { computed } from 'vue';
import { toValue } from '../../vueuse/toValue';
import { useDataStore } from '../../../composables/useVuexStore';
import { COLORS, SELECTED_COLOR } from '../../../store_modules/traitsStore/types';

function connectToStore() {
  const selectedStore = useDataStore(SELECTED_COLOR);
  const dataStore = useDataStore(COLORS);

  return { dataStore, selectedStore };
}

/**
 * Initializes the data
 * @param {{ id: string, data: ParsedColors}} obj
 */
export function useInitColor({ id, data }) {
  const { dataStore, selectedStore } = connectToStore();

  /**
  * @param {ParsedColors} colorData
  */
  function setDefaultColor(colorData) {
    selectedStore.set(id, colorData.colorMap[colorData.selectedColor] || null);
  }

  if (!selectedStore.has(id)) {
    setDefaultColor(data);
  }

  if (!dataStore.has(id)) {
    dataStore.set(id, data);
  }
}

/**
 * TODO improve docs
 * @param {import('@vueuse/core').MaybeRef<string>} id
 */
export function useColor(id) {
  const { dataStore, selectedStore } = connectToStore();

  const parsedData = computed(() => dataStore.get(toValue(id)));
  const colors = computed(() => parsedData.value?.colorArray || []);

  /**
   * @param {Color | ColorId | string | null} color
   */
  function setColor(color) {
    if (typeof color === 'number' || typeof color === 'string') {
      selectedStore.set(toValue(id), parsedData.value?.colorMap[color] || null);
    } else {
      selectedStore.set(toValue(id), color);
    }
  }

  const selectedColor = computed({
    get() {
      return selectedStore.get(toValue(id));
    },
    set(newValue) {
      setColor(newValue);
    },
  });

  const selectedColorId = computed({
    get() {
      return selectedColor.value?.id ?? null;
    },
    set(newValue) {
      setColor(newValue);
    },
  });

  return {
    colors,
    selectedColor,
    selectedColorId,
  };
}
